import styled from 'styled-components';
import colors from 'styles/colors';
import sizes from 'styles/sizes';
import Button from 'components/buttons/Button';
import fonts from 'styles/fonts';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  background: ${colors.functional.paleGrey};
  border-radius: 5px;
  margin: 20px 0;
  min-height: 214px;
  padding: 20px;
  width: 100%;
  @media (min-width: ${sizes.media.tabletPortrait}px) {
    display: flex;
    flex-wrap: wrap;
    padding: 30px 25px;
  }
  
}
`;

export const LabelMessage = styled.p`
  font-family: ${fonts.primary.semibold};
  margin-left: auto;
  margin-right: auto;
  margin-top: auto;
  margin-bottom: auto;

  width: 100%;
  height: 30px;

  font-size: 20px;
  line-height: 150%;

  text-align: center;

  color: ${colors.secondary.deepCove};

  @media (max-width: ${sizes.media.smallMaxWidth}px) {
    font-size: 16px;
    line-height: 24px;
  }
`;

export const ButtonRetry = styled(Button)`
  margin-left: auto;
  margin-right: auto;
  margin-top: auto;
  margin-bottom: auto;
`;
